import React, { useCallback } from 'react';
import { Box, Grid, InputAdornment, makeStyles, Button, IconButton } from '@material-ui/core';
import { Add as AddIcon, RemoveCircle } from '@material-ui/icons';
import PropTypes from 'prop-types';
import CheckboxPicker from '../../../common/forms/CheckboxPicker';
import InputField from '../../../common/forms/InputField';
import CurrencyFormat from './CurrencyFormat';

const useStyles = makeStyles(theme => ({
  itemIntervention: {
    marginBottom: '0',
  },
  itemAmount: {
    backgroundColor: theme.palette.neutrals[3],
  },
  budgetRow: {
    position: 'relative',
    padding: '0 12px',
    marginBottom: '8px',
    backgroundColor: theme.palette.neutrals[1],
    borderRadius: '4px',
  },
  removeButton: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    padding: '4px',
  },
  removeIcon: {
    color: theme.palette.neutrals[4],
    fontSize: '18px',
    '&:hover': {
      color: theme.palette.colorsPalette.RustRed,
    },
  },
  addButton: {
    marginBottom: '8px',
  },
}));

const MultipleBudgets = ({ state, updateField, entityIndex }) => {
  const classes = useStyles();

  const { hasBudget, budgets = [], errors = {} } = state;

  // const handleToggleHasBudget = useCallback(() => {
  //   const newHasBudget = !hasBudget;
  //   updateField('hasBudget', newHasBudget);

  //   if (newHasBudget && budgets.length === 0) {
  //     updateField('budgets', [{ id: Date.now(), budgetNumber: '', amount: '' }]);
  //   }
  // }, [hasBudget, budgets, updateField]);

  const handleToggleHasBudget = useCallback(() => {
    const newHasBudget = !hasBudget;

    if (newHasBudget && budgets.length === 0) {
      updateField('hasBudget', newHasBudget, [{ id: Date.now(), budgetNumber: '', amount: '', intervention: '' }]);
    } else {
      updateField('hasBudget', newHasBudget);
    }
  }, [hasBudget, budgets, updateField]);

  const handleAddBudget = useCallback(() => {
    const newBudgets = [...budgets, { id: Date.now(), budgetNumber: '', amount: '', intervention: '' }];
    updateField('budgets', newBudgets);
  }, [budgets, updateField]);

  const handleRemoveBudget = useCallback(
    index => {
      const newBudgets = budgets.filter((_, idx) => idx !== index);
      updateField('budgets', newBudgets);
    },
    [budgets, updateField]
  );

  const handleBudgetFieldChange = useCallback(
    (budgetIndex, fieldName, value) => {
      const newBudgets = [...budgets];
      newBudgets[budgetIndex] = { ...newBudgets[budgetIndex], [fieldName]: value };
      updateField('budgets', newBudgets);
    },
    [budgets, updateField]
  );

  return (
    <>
      <Box height="20px" />
      <CheckboxPicker
        label="Associar compromissos"
        checked={hasBudget}
        onClick={handleToggleHasBudget}
      />
      <Box height="20px" />

      {hasBudget && (
        <>
          {budgets.map((budget, budgetIndex) => {
            const budgetNumberError = errors[`budgetNumber${budgetIndex}`] || '';
            // const amountError = errors[`amount${budgetIndex}`] || '';

            return (
              <Box key={budget.id || `budget-${budgetIndex}`} className={classes.budgetRow}>
                {budgets.length > 1 && budgetIndex > 0 && (
                  <IconButton
                    className={classes.removeButton}
                    onClick={() => handleRemoveBudget(budgetIndex)}
                    size="small"
                  >
                    <RemoveCircle className={classes.removeIcon} />
                  </IconButton>
                )}

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <InputField
                      label="Intervenção"
                      name={`intervention-${entityIndex}-${budgetIndex}`}
                      value={budget.intervention || ''}
                      onChange={e => handleBudgetFieldChange(budgetIndex, 'intervention', e.target.value)}
                      InputProps={{
                        className: classes.itemIntervention
                      }}
                      className={classes.itemIntervention}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputField
                      label="Número do compromisso"
                      name={`budgetNumber-${entityIndex}-${budgetIndex}`}
                      value={budget.budgetNumber || ''}
                      onChange={e => handleBudgetFieldChange(budgetIndex, 'budgetNumber', e.target.value)}
                      error={budgetNumberError}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputField
                      label="Valor do apoio"
                      // helperText="Valor associado à proposta"
                      name={`amount-${entityIndex}-${budgetIndex}`}
                      value={budget.amount || ''}
                      margin="none"
                      placeholder="0 000.00"
                      onChange={(nameInput, value) => handleBudgetFieldChange(budgetIndex, 'amount', value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">€</InputAdornment>,
                        inputComponent: CurrencyFormat,
                        className: classes.itemAmount,
                      }}
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                    <InputField
                      label="Intervenção"
                      name={`intervention-${entityIndex}-${budgetIndex}`}
                      value={budget.intervention || ''}
                      onChange={e => handleBudgetFieldChange(budgetIndex, 'intervention', e.target.value)}
                    />
                  </Grid> */}
                </Grid>
              </Box>
            );
          })}

          <Button
            startIcon={<AddIcon />}
            variant="text"
            color="primary"
            size="small"
            onClick={handleAddBudget}
            className={classes.addButton}
          >
            Adicionar Compromisso
          </Button>
        </>
      )}
    </>
  );
};

MultipleBudgets.defaultProps = {
  entityIndex: 0,
};

MultipleBudgets.propTypes = {
  state: PropTypes.shape({
    hasBudget: PropTypes.bool,
    budgets: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        budgetNumber: PropTypes.string,
        amount: PropTypes.string,
        intervention: PropTypes.string
      })
    ),
    errors: PropTypes.object,
  }).isRequired,
  updateField: PropTypes.func.isRequired,
  entityIndex: PropTypes.number,
};

export default React.memo(MultipleBudgets);
